<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <br>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-data-table :headers="headers" :items="salary_partial_summary_list" class="elevation-1 mytable"
            :search="search">
            <template v-slot:top>
                <v-toolbar class="toolbar" flat color="white">
                    <v-toolbar-title>Salary Partial Summary</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row dense>
                    <v-col cols="12" sm="3" md="3">
                        <v-btn color="success" outlined rounded v-if="salary_partial_summary_list.length != 0">
                            <download-excel class="mr-2 pb-3 pt-2" :data="salary_partial_summary_list"
                                :fields="table_fields" worksheet="PayRollPartialSalarySummary"
                                name="PayRollPartialSalarySummary.xls">
                                <v-icon dark>mdi-file-excel</v-icon> Export
                            </download-excel>
                        </v-btn>
                    </v-col>
                    <v-col sm="6" md="4" cols="12">
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                        </v-text-field>
                    </v-col>
                    <span style="width: 20px;"></span>
                    <v-dialog v-model="dialog" max-width="500px">
                        <template v-slot:activator="{ on }">
                            <v-btn color="mb-2 button" v-on="on">Add Salary Partial Summary</v-btn>
                        </template>
                        <v-card>
                            <v-form v-model="valid">
                                <v-card-title>
                                    <span class="headline">{{ formTitle }}</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-container>
                                        <v-row>
                                            <!-- <v-col cols="12" sm="12" md="12">
                                                <v-autocomplete
                                                    v-if="editedIndex === -1"
                                                    dense
                                                    v-model="editedItem.employee_type_id"
                                                    :items="employee_type_list"
                                                    label="Employee Type"
                                                    item-text="name"
                                                    item-value="id"
                                                    single-line
                                                    rounded
                                                    outlined
                                                    :rules="[(v) => !!v || 'required']"
                                                ></v-autocomplete>

                                                <v-text-field persistent-hint :hint="'Readonly'" v-else v-model="editedItem.employee_type_name" label="Employee Type" :rules="[(v) => !!v || 'required']" rounded outlined dense readonly>
                                                </v-text-field>
                                            </v-col> -->

                                            <v-col cols="12" sm="12" md="12">
                                                <v-autocomplete v-if="editedIndex === -1" dense
                                                    v-model="editedItem.salary_month_id" :items="salary_month_list"
                                                    label="Salary Month" item-text="name" item-value="id" single-line
                                                    rounded outlined
                                                    :rules="[(v) => !!v || 'required']"></v-autocomplete>

                                                <v-text-field persistent-hint :hint="'Readonly'" v-else
                                                    v-model="editedItem.salary_month_name" label="Salary Month"
                                                    :rules="[(v) => !!v || 'required']" rounded outlined dense readonly>
                                                </v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="12" md="12">
                                                <v-text-field v-model="editedItem.name" persistent-hint :hint="
                            editedIndex == -1
                              ? 'For example :: June-10%,July-50%'
                              : 'For example :: June-10%,July-50%'
                          " label="Enter Name" :rules="[(v) => !!v || 'required']" rounded outlined dense>
                                                </v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="12" md="12">
                                                <v-text-field v-model="editedItem.installment_no" persistent-hint :hint="
                            editedIndex == -1
                              ? 'For example :: 1,2'
                              : 'For example :: 1,2'
                          " label="Installment Number" :rules="[(v) => !!v || 'required']" rounded outlined dense
                                                    type="number">
                                                </v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="12" md="12">
                                                <v-text-field v-model="editedItem.description" persistent-hint :hint="
                            editedIndex == -1
                              ? 'For example :: June-10%,July-50%'
                              : 'For example :: June-10%,July-50%'
                          " label="Description" :rules="[(v) => !!v || 'required']" rounded outlined dense>
                                                </v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="12" md="12">
                                                <v-text-field v-model="editedItem.percentage" persistent-hint :hint="
                            editedIndex == -1
                              ? 'For example :: 10,25'
                              : 'For example :: 10,25'
                          " label="Percentage" :rules="[(v) => !!v || 'required']" rounded outlined dense
                                                    type="number">
                                                </v-text-field>
                                            </v-col>

                                            <!-- <v-col cols="12" sm="12" md="12">
                                                <v-checkbox v-model="editedItem.isfreezed" color="success" label="Is Freezed?"></v-checkbox>
                                            </v-col>

                                            <v-col cols="12" sm="12" md="12">
                                                <v-checkbox v-model="editedItem.is_salary_released" color="success" label="Is Salary Released?"></v-checkbox>
                                            </v-col> -->
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="mb-2 button" text @click="close">Cancel</v-btn>
                                    <v-btn color="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                                </v-card-actions>
                            </v-form>
                        </v-card>
                    </v-dialog>
                </v-row>
            </template>
            <template v-slot:item.isfreezed="{ item }">
                <span v-if="item.isfreezed">
                    <v-icon small class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                </span>
                <span v-else>
                    <v-icon small class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                </span>
            </template>

            <template v-slot:item.is_salary_released="{ item }">
                <span v-if="item.is_salary_released">
                    <v-icon small class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                </span>
                <span v-else>
                    <v-icon small class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                </span>
            </template>

            <template v-slot:item.action="{ item }">
                <div>
                    <v-avatar style="" size="25" class="edit-avatar">
                        <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                    </v-avatar>
                </div>
            </template>
        </v-data-table>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            valid: false,
            overlay: false,
            menu1: false,
            menu2: false,
            // extraBreadcrumbItems: [
            //     { text: "Partial Salary Summary", disabled: true, href: "" },

            // ],
            // breadcrumbClass: "breadcrumb-style1",
            errorMsg: {
                castId: false,
            },
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",
            dialog: false,
            headers: [
                // {
                //     text: "Employee Type",
                //     align: "left",
                //     sortable: false,
                //     value: "employee_type_name",
                // },
                {
                    text: "Salary Month",
                    align: "left",
                    sortable: false,
                    value: "salary_month_name",
                },
                {
                    text: "Name",
                    align: "left",
                    sortable: false,
                    value: "name",
                },
                {
                    text: "Installment No",
                    align: "left",
                    sortable: false,
                    value: "installment_no",
                },
                {
                    text: "Description",
                    align: "left",
                    sortable: false,
                    value: "description",
                },
                {
                    text: "Percentage",
                    align: "left",
                    sortable: false,
                    value: "percentage",
                },
                // {
                //     text: "Salary Released",
                //     align: "left",
                //     sortable: false,
                //     value: "is_salary_released",
                // },
                // {
                //     text: "Salary Freezed",
                //     align: "left",
                //     sortable: false,
                //     value: "isfreezed",
                // },
                // {
                //   text: 'Is Active?',
                //   align: 'left',
                //   sortable: false,
                //   value: 'isactive',
                // },
                { text: "Actions", value: "action", sortable: false },
            ],
            table_fields: {
                "Employee Type": "employee_type_name",
                "Salary Month": "salary_month_name",
                Name: "name",
                "Installment No": "installment_no",
                Description: "description",
                Percentage: "percentage",
                "Salary Released": "is_salary_released",
                "Salary Freezed": "isfreezed",
            },
            salary_month_list: [],
            salary_partial_summary_list: [],
            employee_type_list: [],
            editedIndex: -1,
            editedItem: {
                partialSalarySummaryId: "",
                name: "",
                description: "",
                percentage: "",
                installment_no: "",
                is_salary_released: "",
                isfreezed: "",
                salary_month_id: "",
                salary_month_name: "",
                employee_type_id: "",
                employee_type_name: "",
                //isActive:true,
            },
            defaultItem: {
                partialSalarySummaryId: "",
                name: "",
                description: "",
                percentage: "",
                installment_no: "",
                is_salary_released: "",
                isfreezed: "",
                salary_month_id: "",
                salary_month_name: "",
                employee_type_id: "",
                employee_type_name: "",
                //isActive:true,
            },
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New Salary Partial Summary" : "Edit Salary Partial Summary";
            },
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        mounted() {
            this.onLoad();
        },
        methods: {
            initializeErrorMsgFalse() {
                this.errorMsg.castId = false;
            },

            onLoad() {
                this.overlay = true;
                axios
                    .post("/Payroll/getSalaryPartialSummaryList")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if ((this.load = true)) {
                                this.overlay = false;
                                this.salary_partial_summary_list = res.data.salary_partial_summary_list;
                                this.salary_month_list = res.data.salary_month_list;
                                this.employee_type_list = res.data.employee_type_list;
                            }
                        } else {
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        var overlay = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },

            editItem(item) {
                this.editedIndex = this.salary_partial_summary_list.indexOf(item);
                this.dialog = true;
                this.editedItem.partialSalarySummaryId = item.id;
                this.editedItem.name = item.name;
                this.editedItem.description = item.description;
                this.editedItem.percentage = item.percentage;
                this.editedItem.installment_no = item.installment_no;
                this.editedItem.is_salary_released = item.is_salary_released;
                this.editedItem.isfreezed = item.isfreezed;
                //this.editedItem.isActive = item.isactive
                this.editedItem.salary_month_id = item.salary_month_id;
                this.editedItem.salary_month_name = item.salary_month_name;
                this.editedItem.employee_type_id = item.employee_type_id;
                this.editedItem.employee_type_name = item.employee_type_name;
            },

            // deleteItem (item) {
            //   const index = this.language_super_master_list.indexOf(item)
            //   confirm('Are you sure you want to delete this item?') && this.language_super_master_list.splice(index, 1)
            // },

            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
            },

            save() {
                if (this.editedIndex > -1) {
                    if (this.isValidated()) {
                        axios
                            .post("/Payroll/editSalaryPartialSummary", this.editedItem)
                            .then((res) => {
                                if (res.data.status.code == "200") {
                                    this.showSnackbar("#4caf50", "Salary Partial Summary Updated Successfully..."); // show snackbar on success
                                    this.onLoad();
                                } else if (res.data.status.code == "NA") {
                                    this.showSnackbar("#b71c1c", "Salary Partial Summary Already Present!!!"); // show snackbar on error
                                }
                            })
                            .catch((error) => {
                                window.console.log(error);
                            });
                        this.close();
                    }
                } else {
                    //window.alert(JSON.stringify(this.editedItem))
                    axios
                        .post("/Payroll/saveSalaryPartialSummary", this.editedItem)
                        .then((res) => {
                            if (res.data.status.code == "200") {
                                this.showSnackbar("#4caf50", "Salary Partial Summary Added Successfully..."); // show snackbar on success
                                this.onLoad();
                            } else if (res.data.status.code == "NA") {
                                this.showSnackbar("#b71c1c", "Salary Partial Summary Already Present!!!"); // show snackbar on error
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });
                    this.close();
                }
            }, // end of save()

            isValidated() {
                if (this.editedItem.partialSalarySummaryId) {
                    return true;
                } else {
                    if (!this.editedItem.partialSalarySummaryId) {
                        this.errorMsg.castId = true;
                    }

                    return false;
                }
            }, // .....end of isValidated()
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>
